module.exports = __webpack_public_path__ + "media/taxi/images/finger-print/print-border-1bfbce3c599bb3cea1bc3be908777d18.png";